import { message } from 'antd';
import { config } from "util/config";
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import { getUieDataSource } from 'components/UIBuilder/SectionFunction/Common';

let setAutoComplete = false;
//Search Address从google map找自动完成地址的数据源
export function searchAddressChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter.length >= config.component.AutoComplete.minimumQueryCharacters && setAutoComplete === false) {
    setAutoComplete = true;

    let options = {
      componentRestrictions: {
        country: [pageComponent.state.country]
      }
    };

    var input = document.getElementById('JobContactSearchAddress');
    var autocomplete = new window.google.maps.places.Autocomplete(input, options);

    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      if (place.place_id.length > 150) {
        message.warning('The address you selected does not exist. Please select another one.');
      } else {
        for (var i = 0; i < place.address_components.length; i++) {
          switch (pageComponent.state.country.toLowerCase()) {
            case 'nz':
              if (place.address_components[i].types[0] == "street_number") {
                formComponent.formRef.current?.setFieldValue('StreetNumber', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "route") {
                formComponent.formRef.current?.setFieldValue('StreetName', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "sublocality_level_1") {
                formComponent.formRef.current?.setFieldValue('Suburb', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "locality") {
                formComponent.formRef.current?.setFieldValue('CityTown', place.address_components[i].short_name);
              }
              if (place.address_components[i].types[0] == "postal_code") {
                formComponent.formRef.current?.setFieldValue('Postcode', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "country") {
                formComponent.formRef.current?.setFieldValue('Country', place.address_components[i].long_name);
              }
              break;
            default:
              if (place.address_components[i].types[0] == "street_number") {
                formComponent.formRef.current?.setFieldValue('StreetNumber', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "route") {
                formComponent.formRef.current?.setFieldValue('StreetName', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "locality") {
                formComponent.formRef.current?.setFieldValue('Suburb', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "administrative_area_level_1") {
                formComponent.formRef.current?.setFieldValue('State', place.address_components[i].short_name);
              }
              if (place.address_components[i].types[0] == "postal_code") {
                formComponent.formRef.current?.setFieldValue('Postcode', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "country") {
                formComponent.formRef.current?.setFieldValue('Country', place.address_components[i].long_name);
              }
              break;
          }
        }
        formComponent.formRef.current?.setFieldValue('JobContactSearchAddress', place.formatted_address);
      }
    })
  }
}

export function addClientJobTemplateContactPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setAutoComplete = false;
}

export function editClientJobTemplateContactPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setAutoComplete = false;
}

//选Same As Contact Address时给Postal Address赋值
export function setSameAsContactAddress({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter) {
    formComponent.formRef.current?.setFieldValue('PostalStreetNumber', formComponent.formRef.current?.getFieldValue('StreetNumber'));
    formComponent.formRef.current?.setFieldValue('PostalStreetName', formComponent.formRef.current?.getFieldValue('StreetName'));
    formComponent.formRef.current?.setFieldValue('PostalSuburb', formComponent.formRef.current?.getFieldValue('Suburb'));
    formComponent.formRef.current?.setFieldValue('PostalState', formComponent.formRef.current?.getFieldValue('State'));
    formComponent.formRef.current?.setFieldValue('PostalCityTown', formComponent.formRef.current?.getFieldValue('CityTown'));
    formComponent.formRef.current?.setFieldValue('PostalPostcode', formComponent.formRef.current?.getFieldValue('Postcode'));
    formComponent.formRef.current?.setFieldValue('PostalCountry', formComponent.formRef.current?.getFieldValue('Country'));
  } else {
    formComponent.formRef.current?.setFieldValue('PostalStreetNumber', '');
    formComponent.formRef.current?.setFieldValue('PostalStreetName', '');
    formComponent.formRef.current?.setFieldValue('PostalSuburb', '');
    formComponent.formRef.current?.setFieldValue('PostalState', '');
    formComponent.formRef.current?.setFieldValue('PostalCityTown', '');
    formComponent.formRef.current?.setFieldValue('PostalPostcode', '');
    formComponent.formRef.current?.setFieldValue('PostalCountry', '');
  }
}

//CopyFrom 快速填写数据
export function copyFromClientJobTemplateContact({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter > 0) {
    httpClient
      .get('/Admin/ClientJobTemplateContact/' + parameter)
      .then(({ data }) => {
        if (data.result) {
          formComponent.formRef.current?.setFieldValue('FirstName', data.data.FirstName);
          formComponent.formRef.current?.setFieldValue('LastName', data.data.LastName);
          formComponent.formRef.current?.setFieldValue('Company', data.data.Company);
          formComponent.formRef.current?.setFieldValue('JobTitle', data.data.JobTitle);
          formComponent.formRef.current?.setFieldValue('Phone', data.data.Phone);
          formComponent.formRef.current?.setFieldValue('Mobile', data.data.Mobile);
          formComponent.formRef.current?.setFieldValue('Email', data.data.Email);
          formComponent.formRef.current?.setFieldValue('BusinessNo', data.data.BusinessNo);
          formComponent.formRef.current?.setFieldValue('BuilderSubsection24b', data.data.BuilderSubsection24b);

          formComponent.formRef.current?.setFieldValue('StreetNumber', data.data.StreetNumber);
          formComponent.formRef.current?.setFieldValue('StreetName', data.data.StreetName);
          formComponent.formRef.current?.setFieldValue('Suburb', data.data.Suburb);
          formComponent.formRef.current?.setFieldValue('State', data.data.State);
          formComponent.formRef.current?.setFieldValue('CityTown', data.data.CityTown);
          formComponent.formRef.current?.setFieldValue('Postcode', data.data.Postcode);
          formComponent.formRef.current?.setFieldValue('Country', data.data.Country);

          formComponent.formRef.current?.setFieldValue('PostalStreetNumber', data.data.PostalStreetNumber);
          formComponent.formRef.current?.setFieldValue('PostalStreetName', data.data.PostalStreetName);
          formComponent.formRef.current?.setFieldValue('PostalSuburb', data.data.PostalSuburb);
          formComponent.formRef.current?.setFieldValue('PostalPostcode', data.data.PostalPostcode);
          formComponent.formRef.current?.setFieldValue('PostalState', data.data.PostalState);
          formComponent.formRef.current?.setFieldValue('PostalCityTown', data.data.PostalCityTown);
          formComponent.formRef.current?.setFieldValue('PostalCountry', data.data.PostalCountry);

          formComponent.formRef.current?.setFieldValue('RegNum', data.data.RegNum);
          formComponent.formRef.current?.setFieldValue('CompanyRegNum', data.data.CompanyRegNum);
          formComponent.formRef.current?.setFieldValue('PractitionerType', data.data.PractitionerType !== null ? data.data.PractitionerType : -1);
          formComponent.formRef.current?.setFieldValue('PractitionerClass', data.data.PractitionerClass);
          formComponent.formRef.current?.setFieldValue('NominatedLevyPayer', data.data.NominatedLevyPayer);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

export function addSubmitFinish({ sectionName, formComponent, sectionComponent, pageComponent }) {
  let componentDataSource = { ...formComponent.state.componentDataSource };
  componentDataSource.CopyFrom = undefined;
  formComponent.setState({ componentDataSource });
}

//AddFromContact 找自动完成联系人的数据源
export function searchContactChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  parameter = parameter.replace(/#/g, '');
  if (parameter.length >= config.component.AutoComplete.minimumQueryCharacters && !uie.autoDataSource && uie.datasourceUrl !== null) {
    httpClient
      .get(uie.datasourceUrl + '?keyword=' + parameter + '&moduleId=' + pageComponent.state.moduleId)
      .then(({ data }) => {
        let options = [];
        if (data.result) {
          data.data.map((contact, j) => {
            options.push({ label: contact.FullNameCompany, value: contact.FullNameCompany, data: contact });
          })
          let componentDataSource = { ...formComponent.state.componentDataSource };
          componentDataSource[uie.source] = options;
          formComponent.setState({ componentDataSource });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//AddFromContact 选择后快速填写数据
export function searchContactSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let data = parameter;
  formComponent.formRef.current?.setFieldValue('FirstName', data.data.FirstName);
  formComponent.formRef.current?.setFieldValue('LastName', data.data.LastName);
  formComponent.formRef.current?.setFieldValue('Company', data.data.Company);
  formComponent.formRef.current?.setFieldValue('JobTitle', data.data.JobTitle);
  formComponent.formRef.current?.setFieldValue('Phone', data.data.Phone);
  formComponent.formRef.current?.setFieldValue('Mobile', data.data.Mobile);
  formComponent.formRef.current?.setFieldValue('Email', data.data.Email);
  formComponent.formRef.current?.setFieldValue('BusinessNo', data.data.BusinessNo);

  formComponent.formRef.current?.setFieldValue('StreetNumber', data.data.StreetNumber);
  formComponent.formRef.current?.setFieldValue('StreetName', data.data.StreetName);
  formComponent.formRef.current?.setFieldValue('Suburb', data.data.Suburb);
  formComponent.formRef.current?.setFieldValue('State', data.data.State);
  formComponent.formRef.current?.setFieldValue('CityTown', data.data.CityTown);
  formComponent.formRef.current?.setFieldValue('Postcode', data.data.Postcode);
  formComponent.formRef.current?.setFieldValue('Country', data.data.Country);

  formComponent.formRef.current?.setFieldValue('PostalStreetNumber', data.data.PostalStreetNumber);
  formComponent.formRef.current?.setFieldValue('PostalStreetName', data.data.PostalStreetName);
  formComponent.formRef.current?.setFieldValue('PostalSuburb', data.data.PostalSuburb);
  formComponent.formRef.current?.setFieldValue('PostalPostcode', data.data.PostalPostcode);
  formComponent.formRef.current?.setFieldValue('PostalState', data.data.PostalState);
  formComponent.formRef.current?.setFieldValue('PostalCityTown', data.data.PostalCityTown);
  formComponent.formRef.current?.setFieldValue('PostalCountry', data.data.PostalCountry);

  formComponent.formRef.current?.setFieldValue('RegNum', data.data.RegNum);
  formComponent.formRef.current?.setFieldValue('CompanyRegNum', data.data.CompanyRegNum);
  formComponent.formRef.current?.setFieldValue('PractitionerClass', data.data.PractitionerClass);
}
